import type * as Sentry from "@sentry/nextjs";
import { LoggerLevelEnum } from "@/enums";
import type { LoggerLevel } from "@/types";

export function toSentryLevel(level: LoggerLevel): Sentry.SeverityLevel {
  switch (level) {
    case LoggerLevelEnum.DEBUG:
      return "debug";
    case LoggerLevelEnum.INFO:
      return "info";
    case LoggerLevelEnum.WARN:
      return "warning";
    case LoggerLevelEnum.ERROR:
      return "error";
    case LoggerLevelEnum.FATAL:
      return "fatal";
    default:
      return "error";
  }
}
